<div class="bootstrap-wrapper">
    <div *ngIf="reportData" id="onemap-report">
        <div class="reportSectionContainer grid-container">
            <div class="reportSectionHeader">
                <label>Basic Bridge Report</label>
            </div>
            <div class="reportSectionContainer">
                <div class="reportSectionContent container">
                    <div class="row">
                        <div class="col-xs-6">
                            <label>BMS ID:&nbsp;</label>{{ reportData.bridge.bridge_id }}
                        </div>
                        <div class="col-xs-6">
                            <label>Bridge Key:&nbsp;</label>{{ reportData.bridge.brkey }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <span class="legal-note">
                                <label>NOTE:</label>This document contains inspection information and may not be used in legal actions or proceedings against
                                the bridge owner. (Reference 65 P.S. Sec 66.1 et sep., 75 pa. C.S. Sec 3754 and 23 U.S.C. Sec 409.)
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="reportSelectionContainer">
                <div class="reportSectionHeader">
                    <label>Location</label>
                </div>
                <div class="reportSectionContent container">
                    <div class="row">
                        <div class="col-xs-6">
                            <label>County:&nbsp;</label>{{ reportData.bridge.cty_code }}
                        </div>
                        <div class="col-xs-6">
                            <label>Route:&nbsp;</label>{{ reportData.bridge.st_rt_no }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <label>Jurisdiction:&nbsp;</label>{{ reportData.bridge.juris }}
                        </div>
                        <div class="col-xs-6">
                            <label>Location Description:&nbsp;</label>{{ reportData.bridge.location }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="reportSelectionContainer">
                <div class="reportSectionHeader">
                    <label>Bridge Specifications</label>
                </div>
                <div class="reportSectionContent container">
                    <div class="row">
                        <div class="col-xs-6">
                            <label>HBRR Code:&nbsp;</label>{{ reportData.bridge.hbrr_elig }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <label>Posted Restrictions:&nbsp;</label>{{ reportData.bridge.post_status }}
                        </div>
                        <div class="col-xs-6">
                            <label>Year Built:&nbsp;</label>{{ reportData.bridge.yearbuilt }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <label>Owner:&nbsp;</label>{{ reportData.bridge.owner }}
                        </div>
                        <div class="col-xs-6">
                            <label>Structure Type:&nbsp;</label>{{ reportData.bridge.depT_STRUC_DESC }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <label>Deficient/Obsolete:&nbsp;</label>{{ reportData.bridge.nbi_rating }}
                        </div>
                        <div class="col-xs-6">
                            <label>Single Weight Limit (Tons):&nbsp;</label>{{ reportData.bridge.post_limit_weight }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <label>Width:&nbsp;</label>{{ reportData.bridge.deckwidth }}
                        </div>
                        <div class="col-xs-6">
                            <label>Weight Limit Combination (Tons):&nbsp;</label>{{ reportData.bridge.post_limit_comb }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <label>Length:&nbsp;</label>{{ reportData.bridge.length }}
                        </div>
                        <div class="col-xs-6">
                            <label># Spans:&nbsp;</label>{{ reportData.bridge.mainspans }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <label>Latitude:&nbsp;</label>{{ reportData.bridge.dec_lat }}
                        </div>
                        <div class="col-xs-6">
                            <label>Condition Rating - Deck:&nbsp;</label>{{ reportData.bridge.dkrating }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <label>Longitude:&nbsp;</label>{{ reportData.bridge.dec_long }}
                        </div>
                        <div class="col-xs-6">
                            <label>Condition Rating - Sub:&nbsp;</label>{{ reportData.bridge.subrating }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <label>Feature Carried:&nbsp;</label>{{ reportData.bridge.facility }}
                        </div>
                        <div class="col-xs-6">
                            <label>Condition Rating - Super:&nbsp;</label>{{ reportData.bridge.suprating }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <label>Feature Intersected:&nbsp;</label>{{ reportData.bridge.featint }}
                        </div>
                        <div class="col-xs-6">
                            <label>Condition Rating - Culv:&nbsp;</label>{{ reportData.bridge.culvrating }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <label>Functional Class:&nbsp;</label>{{ reportData.bridge.funcclass }}
                        </div>
                        <div class="col-xs-6">
                            <label>AADT:&nbsp;</label>{{ reportData.bridge.adttotal }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <label>Sufficieny Rating:&nbsp;</label>{{ reportData.bridge.suff_rate }}
                        </div>
                        <div class="col-xs-6">
                            <label>Truck Percent:&nbsp;</label>{{ reportData.bridge.truckpct }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="reportSectionContainer">
                <div class="reportSectionHeader">
                    <label>Associated Projects</label>
                </div>
                <div class="reportSectionContent container">
                    <div class="row">
                        <div class="col-xs-3">
                            <label>Project Number</label>
                        </div>
                        <div class="col-xs-3">
                            <label>TYP Approved</label>
                        </div>
                        <div class="col-xs-3">
                            <label>Bridge Bill</label>
                        </div>
                        <div class="col-xs-3">
                            <label>Notice to Proceed</label>
                        </div>
                    </div>
                    <div class="row" *ngFor="let row of reportData.associatedprojects">
                        <div class="col-xs-3">
                            <a href="?projectId={{ row.projectId }}" target="blank">{{ row.projectId }}</a>
                        </div>
                        <div class="col-xs-3">
                            {{ row.appr }}
                        </div>
                        <div class="col-xs-3">
                            {{ row.bridgeBill }}
                        </div>
                        <div class="col-xs-3">
                            <span *ngIf="row.noticeToProceedDate">{{ row.noticeToProceedDate.substring(4,6) }}/{{ row.noticeToProceedDate.substring(6) }}/{{ row.noticeToProceedDate.substring(0,4) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="isGenerating">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">Loading...</div>
    </div>
</div>
<div class="alert alert-red is-active container" *ngIf="error">
    {{ errorMessage }}
</div>
